import type { ChatIntegrationItem } from "schemas/generated/chatMessage";

import React from "react";

export const IntegrationToken: React.FC<{
  data: ChatIntegrationItem;
}> = ({ data }) => {
  return (
    <span className="inline-flex items-center align-middle max-w-full p-1 border-[0.5px] border-border bg-sheet rounded-md">
      <img
        src={data.image}
        alt={data.title}
        className="w-5 h-5 object-contain rounded-sm inline align-baseline mr-1 border border-border"
      />
      <span className="font-medium text-default truncate">{data.title}</span>
    </span>
  );
};
